export const addValuesToAllRows = (obj, goal, totalSpend) => {
  const copy = { ...obj };
  copy.goal = copy[goal.metric] - goal.target;
  copy.totalSpend = totalSpend;
  copy.jotaiGoal = goal;

  return copy;
};
